/**
 * cfcs
 * Copyright (c) 2022-present NAVER Corp.
 * MIT license
 */
import * as modules from "./index";

// co
// for (const name in modules) {
//     (cfcs as any)[name] = (modules as any)[name];
// }

export default modules;
